<mat-card class="approval-summary mat-elevation-z0">
    <mat-card-content>
        <div>
            <div class="label" appLocalizationPopupDirective localizationCode="BuySellApprovalStatus">
                {{ 'BuySellApprovalStatus' | translate: {Default: "Status"} }}
            </div>
            <div class="value">
                <mat-chip-list *ngIf="buySellApproval">
                    <mat-chip
                        [ngClass]="{
                            'red-chip': buySellApproval.status?.id === 'DENIED',
                            'green-chip': buySellApproval.status?.id === 'APPROVED',
                            'orange-chip': buySellApproval.status?.id === 'QUEUED',
                            'blue-chip': buySellApproval.status?.id === 'PENDING_APPROVAL'
                        }"
                    >{{ buySellApproval.status?.text }}</mat-chip>
                </mat-chip-list>
            </div>
        </div>
        <div>
            <div class="label" appLocalizationPopupDirective localizationCode="BuySellRequestOn">{{ 'BuySellRequestOn' | translate: {Default: "Request On"} }}</div>
            <div class="value">{{buySellApproval?.version?.createdOn | date: 'longDate'}}</div>
        </div>
        <div>
            <div class="label" appLocalizationPopupDirective localizationCode="BuySellSubmittedBy">{{ 'BuySellSubmittedBy' | translate: {Default: "Submitted By"} }}</div>
            <div class="value">
                <app-employee-label [employee]="buySellApproval?.version?.createdBy"></app-employee-label>
            </div>
        </div>
        <div class="detail-row">
            <div class="label" appLocalizationPopupDirective localizationCode="BuySellRequestType">{{ 'BuySellRequestType' | translate: {Default: "Request Type"} }}</div>
            <div class="value">
                {{ selectedType === 'BUY' ? 'Buy' : 'Sell' }}
            </div>
        </div>

        <div class="detail-row">
            <div class="label" appLocalizationPopupDirective localizationCode="BuySellRequestedHours">{{ 'BuySellRequestedHours' | translate: {Default: "Requested Hours"} }}</div>
            <div class="value">
                {{ buySellPlanEmployee?.hours }}
            </div>
        </div>

        <div class="detail-row">
            <div class="label" appLocalizationPopupDirective localizationCode="BuySellHourlyRate">{{ 'BuySellHourlyRate' | translate: {Default: "Hourly Rate"} }}</div>
            <div class="value">
                {{ compensation?.payRateCurrency?.id | currencyDisplay: buySellPlanEmployee?.hourlyCost }}
            </div>
        </div>

        <div class="detail-row">
            <div *ngIf="selectedType === 'BUY'" class="label" appLocalizationPopupDirective localizationCode="SalaryDeduction">
                {{ 'SalaryDeduction' | translate: {Default: "Salary Deduction"} }}
            </div>
            <div *ngIf="selectedType === 'SELL'" class="label" appLocalizationPopupDirective localizationCode="SalaryAddition">
                {{ 'SalaryAddition' | translate: {Default: "Salary Addition"} }}
            </div>
            <div class="value">
                {{ compensation?.payRateCurrency?.id | currencyDisplay: buySellPlanEmployee?.hours * buySellPlanEmployee?.hourlyCost }}
            </div>
        </div>

        <div class="action-buttons" *ngIf="buySellApproval?.status?.id === 'PENDING_APPROVAL'">
            <button color="warn" mat-raised-button appLocalizationPopupDirective localizationCode="DenyButton" appPreventDoubleClick (throttledClick)="openApproveDenyDialog('deny')" *ngIf="buySellApproval?.status?.id === 'PENDING_APPROVAL'">
                <mat-icon class="material-icons-outlined">cancel</mat-icon>
                {{ 'DenyButton' | translate: {Default: "Deny"} }}
            </button>
            <button class="green-chip" mat-raised-button appLocalizationPopupDirective localizationCode="ApproveButton" appPreventDoubleClick (throttledClick)="openApproveDenyDialog('approve')" *ngIf="buySellApproval?.status?.id === 'PENDING_APPROVAL'">
                <mat-icon class="material-icons-outlined">check_circle</mat-icon>
                {{ 'ApproveButton' | translate: {Default: "Approve"} }}
            </button>
        </div>
    </mat-card-content>
</mat-card>